import { render, staticRenderFns } from "./tableProductsPreApproved.vue?vue&type=template&id=cf2ef21e&scoped=true"
import script from "./tableProductsPreApproved.vue?vue&type=script&lang=js"
export * from "./tableProductsPreApproved.vue?vue&type=script&lang=js"
import style0 from "./tableProductsPreApproved.vue?vue&type=style&index=0&id=cf2ef21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ef21e",
  null
  
)

export default component.exports